module.exports = "../study/imgs/maps/Tokyo/S8/Agriculture/RiceQ/Tokyo_RiceQ_MIROC5_RCP26_Now.png";